<igo-share-map-url [map]="map()" />
